
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-23-dec.webp'


const Event29 = () => {
    useEffect(() => {
        document.title = "Distinguished Lecture  on Digital Twin in Built Enviroment";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>23 December 2025</h1>
        <h3 className='text-center'>Distinguished Lecture  on Digital Twin in Built Enviroment  </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='Distinguished Lecture  on Digital Twin in Built Enviroment'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/gIQBquEQubY=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event29




